import React, { useState } from "react";
import StaffBio from "../../../modals/StaffBio";

interface StaffMember {
  name: string;
  role: string;
  image: string;
  alt: string;
}

interface Props {
  member: StaffMember;
}

const StaffMemberCard: React.FC<Props> = ({ member }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center cursor-pointer transition-all duration-300 hover:border-white/30 hover:shadow-lg hover:shadow-[#00A3FF]/10 hover:scale-[1.02] flex flex-col items-center"
        onClick={() => setIsModalOpen(true)}
      >
        <div className="relative mb-5">
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#00A3FF] to-[#0077CC] opacity-0 group-hover:opacity-20 transition-opacity duration-300 blur-xl"></div>
          <img
            src={member.image}
            alt={member.alt}
            className="relative w-32 h-32 rounded-full object-cover shadow-lg border-4 border-white/10 group-hover:border-[#00A3FF]/50 transition-all duration-300"
          />
        </div>
        <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#00A3FF] transition-colors duration-300">
          {member.name}
        </h3>
        <p className="text-gray-300 text-sm">{member.role}</p>
      </div>

      <StaffBio
        member={member}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
      />
    </>
  );
};

export default StaffMemberCard;
